<section class="file-preview-dialog">
  <header class="has-header-text" [ngClass]="getRenderMode()">
    @if (getRenderMode() === 'chrome-extension') {
      <h1 mat-dialog-title class="has-icon compact">
        <div class="title-line">
          <mat-icon fontSet="material-icons-outlined">description</mat-icon>
          <div class="main-title">Previewing</div>
        </div>
        <div class="sub-title" [matTooltip]="filename" matTooltipShowDelay="500">{{ filename }}</div>
      </h1>
    } @else {
      <h1 mat-dialog-title class="has-icon">
        <mat-icon fontSet="material-icons-outlined">description</mat-icon>
        <div class="main-title">Previewing</div>
        <div class="sub-title truncate" [matTooltip]="filename" matTooltipShowDelay="500">{{ filename }}</div>
      </h1>
    }
    <mat-icon class="close-dialog" fontIcon="close" (click)="onClose()" matTooltip="Close preview" matTooltipShowDelay="500"> </mat-icon>
  </header>

  <div mat-dialog-content class="modal-content">
    @if (isLoading) {
      <div class="loading-message">
        <span class="preview-spinner"></span>
        <p>{{ loadingMessage }}</p>
      </div>
    } @else if (errorMessage) {
      <div class="error-message">
        <p>{{ errorMessage }}</p>
      </div>
    } @else if (data) {
      <lib-file-preview [data]="data"></lib-file-preview>
    }
  </div>

  <section mat-dialog-actions class="footer-btns">
    <button
      mat-button
      (click)="onClose()"
      theme-style="nav"
      class="danger-btn-hover"
      matTooltip="Close preview"
      matTooltipShowDelay="500"
      appRipple
    >
      CLOSE
    </button>
    <button
      mat-button
      (click)="onDownload()"
      theme-style="nav"
      matTooltip="Download original file"
      matTooltipShowDelay="500"
      appRipple
      [disabled]="!data?.originalFileContent"
    >
      <mat-icon fontSet="material-symbols-outlined">download</mat-icon>
      DOWNLOAD FILE
    </button>
  </section>
</section>
